<template>
	<div class="content_list" :class="agentMobile ? 'content_list_lg' : ''">
		<div class="normal-list" v-if="listData.length > 0">
			<navCard
				v-for="(item, index) in listData"
				:key="index"
				:navIndex="index"
				:navId="item.id"
				:title="item.reportName"
				:hospitalName="item.hospital"
				:checkTime="item.time"
				:navType="navType"
				:searchType="searchType"
				@toDetail="getIndex"
			></navCard>
		</div>
		<mescroll-empty v-if="nullFlg" :option="emptyOption"></mescroll-empty>
	</div>
</template>

<script>
// import util from '@/pagesB/utils/util.js';
import {getPatientInfo} from '../../../../api/appletApi'
import navCard from '../../components/navCard.vue'
import mescrollEmpty from '../../components/mescrollEmpty.vue'
export default {
  components: {
    navCard,
    mescrollEmpty
  },
  data () {
    return {
      name: 'report',
      emptyOption: {
        use: true,
        icon: '/static/null.png',
        tip: '没有检验数据'
      },
      agentMobile: '',
      page: 1,
      pageSize: 10,
      total: 0,
      searchData: {
        start: '',
        end: '',
        hospital: '',
        type: []
      },
      searchType: 'report', // 搜索类型
      navType: '5', // 列表显示类型
      listData: [
        // {
        // 	age: "73岁",
        // 	hospital: "温州医科大学附属第二医院",
        // 	id: "1",
        // 	name: "徐双日",
        // 	reportName: "血清",
        // 	time: "2020/11/27"
        // }
      ],
      allList: [],
      patId: '',
      nullFlg: false
    }
  },
  mounted () {
    this.patId = this.$route.query.patId
    this.getList()
  },
  methods: {
    // 获取列表
    getList () {
      // let mpi = '405372784';
      // let patName = '郭志芳'
      // let data = {
      // 	Header: 'MCIP_JY_JIANYANBGCX',
      // 	Body: {
      // 		"MPI":mpi,
      // 		"XingMing":patName
      // 	}
      // };
      this.loading = false
      let that = this
      getPatientInfo({
        infoType: 1,
        patId: this.patId
      })
        .then(data => {
          this.loading = true
          if (data.length === 0) {
            this.nullFlg = true
            return
          }
          let list = data
          list.forEach((item, index) => {
            let info = {
              reportName: item.jianYanMD,
              hospital: item.baoGaoJGMC,
              time: item.baoGaoSJ,
              navType: 8
            }

            that.listData.push(info)
            that.allList.push(item)
          })
        })
    },
    getIndex (res) {
      this.$router.push({name: 'reportDetail', params: this.allList[res]})
    }
  }
}
</script>

<style lang="scss" scoped>
.filter_comp_box {
	background-color: #fe9369;
}
.normal-list {
	margin-top: 12px;
	padding: 0 12px;
}
.list_none {
	width: 100%;
	text-align: center;
	font-size: 14px;
	color: #666;
	padding: 50px 0;
}
</style>



// WEBPACK FOOTER //
// packages/appletView/src/pages/report/report.vue